// @flow

import React from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import ModalDialog from '../ModalDialog/ModalDialog';
import OrderRowNoteForm from '../OrderRowNoteForm/OrderRowNoteForm';
import ServerError from '../ServerError/ServerError';

export type Props = {
  error: ?any,
  formValues: any,
  isLoading: boolean,
  onClose: Function,
  onSave: Function,
  orderRow: any,
  validate: Function,
};

const OrderRowNoteDialog = ({
  error,
  formValues,
  isLoading,
  onClose,
  onSave,
  orderRow,
  validate,
}: Props) => (
  <div>
    <ModalDialog
      onClose={onClose}
      className="OrderRowNoteDialog"
      show={true}>
      <LoadingIndicator isLoading={isLoading} />
      <ServerError error={error} />
      <OrderRowNoteForm
        initialValues={orderRow}
        validate={validate} />
      <button
        type="button"
        className="expanded button"
        onClick={onSave}>
        Spara
      </button>
      <button
        type="button"
        className="expanded button"
        onClick={onClose}>
        Avbryt
      </button>
    </ModalDialog>
  </div>
);

export default OrderRowNoteDialog;



// WEBPACK FOOTER //
// ./src/components/OrderRowNoteDialog/OrderRowNoteDialog.js